import {
    SET_MANAGED_EQUIPMENT_DROP_DOWN
} from "./ManagedEquipmentDropDownType";

const reducer = (state = [], action: any) => {
    switch (action.type) {
        case SET_MANAGED_EQUIPMENT_DROP_DOWN:
            return{
                ...state,
                managedEquipmentDropDown: action.managedEquipmentDropDown
            }
        default:
            return state;
    }
};

export default reducer;
